import { Component, Input, OnInit } from '@angular/core';
import { LanguageService } from 'src/app/services/language.service';
import { LanguageEnum } from '../../models/item.model';
import { SkillTypeEnum } from 'src/app/training-plan/enums/skill-type.enum';
import { JobClassification } from 'src/app/student/models/job-classification';

@Component({
  selector: 'app-job-details',
  templateUrl: './job-details.component.html',
  styleUrl: './job-details.component.scss'
})
export class JobDetailsComponent implements OnInit {
  @Input() jobDetails: JobClassification = {} as JobClassification;
  isRtl: boolean = true;
  getSkillTypeEnum: typeof SkillTypeEnum = SkillTypeEnum;

  constructor(private languageService: LanguageService) { }

  ngOnInit(): void {
    this.isRtl = this.languageService.getCurrentLanguage() === LanguageEnum.ar;
    this.languageService.languageChange.subscribe((result: LanguageEnum) => this.isRtl = result === LanguageEnum.ar)
  }

  getSkillsByType(type: SkillTypeEnum) {
    return this.jobDetails?.skills?.filter(c => c.type === type);
  }

  stringSpliter(value: string, split: string) {
    if (!value) return;

    var arr = value?.split("\n").join("").split(split).filter(c => c);
    return arr.length === 1 ? [value] : arr;
  }
}
